import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../../api/index';
import { withRouter } from 'react-router-dom';
import QRCode from 'qrcode.react';
import styles from './index.module.scss';
import warn from '../../../static/images_cso/warn.png';
import up_down_connect from '../../../static/images_cso/up_down_connect.png';
import plus_fold from '../../../static/images_cso/plus_fold.png';
import get_poster from '../../../static/images_cso/get_poster.png';
import fold_arrrow_down from '../../../static/images_cso//search/fold_arrrow_down.png';
import fold_cover from '../../../static/images_cso//search/fold_cover.png';
import fold_hospital from '../../../static/images_cso//search/fold_hospital.png';
import fold_title from '../../../static/images_cso//search/fold_title.png';
import utils from '../../../utils/utils';
import { Toast, Button } from 'antd-mobile-v5';

const api = new ApiCore();

const env = process.env.REACT_APP_ENV;

const CovidSuggest = (props: any) => {

    const [wxUrl, setWxUrl] = useState('');
    const [drugs, setDrugs] = useState<any>([]);
    const [planCode, setPlanCode] = useState<any>('');
    const [drugState, setDrugState] = useState<any>('');
    const [flowCode, setFlowCode] = useState<any>('');
    const [treatmentPlanCode, setTreatmentPlanCode] = useState<any>('');
    const [showPoster, setShowPoster] = useState<any>(false);
    const [imgUrl, setImgUrl] = useState<any>('');
    const [sourceType, setSourceType] = useState<any>('');
    const [strategyName, setStrategyName] = useState<any>('');
    const [aliasName, setAliasName] = useState<any>('');
    const [needAliasName, setNeedAliasName] = useState<any>('');
    const [orderDrug, setOrderDrug] = useState<any>({});
    const [orderPlanCode, setOrderPlanCode] = useState<any>('');
    const [orderSingleDrug, setOrderSingleDrug] = useState<any>(''); // 是否计入产品选购（多药品处方购
    const [isExpand, setIsExpand] = useState<any>(true);
    const [needFold, setNeedFold] = useState<any>(false);
    const [channelType, setChannelType] = useState<any>();
    const [isOutbound, setIsOutbound] = useState<any>(false); // 是否境外

    useEffect(() => {
        document.title = '治疗建议';
        initCondition()
        initData();
        return () => {
        }
    }, [])

    const initCondition = () => {
        let savedUrlParam = localStorage.getItem('OriginUrlParam');
        if (savedUrlParam) {
            let savedOriginUrlParam: any = {};
            try {
                savedOriginUrlParam = JSON.parse(savedUrlParam)
            } catch (error) {
                savedOriginUrlParam = {};
            }
            let _from = savedOriginUrlParam.from;
            // 自然人进入才折叠
            // if (_from === 'csoDoctorFreeLogin') {
            //     setNeedFold(true);
            //     setIsExpand(false);
            // }
        }
    }

    const initData = async () => {
        let doctor_info = sessionStorage.getItem('cso_doctor_info') || '{}';
        const doctorInfo: any = JSON.parse(doctor_info);
        let urlParams = utils.getUrlParams();
        let projectCode = urlParams.projectCode || '';
        let treatmentPlanCode = urlParams.code || '';
        let needAliasName = urlParams.needAliasName || '';
        let channelType = urlParams.channelType || '';

        setNeedAliasName(needAliasName);
        setTreatmentPlanCode(treatmentPlanCode);
        setChannelType(channelType);
        getInfo().then((data: any) => {
            let _planCode = data.planCode;
            if (!treatmentPlanCode) {
                treatmentPlanCode = _planCode;
                setTreatmentPlanCode(_planCode);
            }
            return api.getDoctorFlowGenerate({
                context: {
                    planCode: '',
                    doctorCode: doctorInfo.code,
                    projectCode: projectCode || doctorInfo.projects[0]?.code,
                    treatmentPlanCode: _planCode
                },
                type: 'DrugOrder' // InvitePatient -> 绑定患者, DrugOrder -> 买药 
            }).then((res: any) => Object.assign(res, { state: data.state}))
        }).then(async (result: any) => {
            const drugState = result.state;
            setDrugState(drugState);
            // state 1: 预购, state: 2 在售
            if (result.code == 0) {
                const _flowCode = result.data || '';
                setFlowCode(result.data);
                let jumpUrl = '';
                const sourceData = await getSourceData(treatmentPlanCode);
                // const sourceType = sourceData?.channel?.wxAppId == 'wxfcf0410b76abcfa1' ? 'xiaohui' : 'gaoji';
                // const sourceType = (sourceData?.channel?.strategyName == 'xiaohui') ? 'xiaohui' : 'gaoji';
                const sourceType = sourceData?.channel?.strategyName || '';
                const strategyName = sourceData?.channel?.strategyName || '';
                const aliasName = sourceData?.channel?.strategyName == 'jingdong' ? (sourceData?.drugs[0]?.aliasName || '') : '';
                const orderDrug = sourceData?.channel?.strategyName == 'jingdong' ? (sourceData?.drugs ? sourceData?.drugs[0] : {}) : {};
                const orderPlanCode = sourceData.planCode;
                const orderSingleDrug = sourceData.singleDrug
                const outTargetUrl = sourceData.outTargetUrl;
                const isOutbound = sourceData.isOutbound;
                setOrderDrug(orderDrug);
                setSourceType(sourceType);
                setStrategyName(strategyName);
                setAliasName(aliasName);
                setOrderPlanCode(orderPlanCode);
                setOrderSingleDrug(orderSingleDrug);
                setIsOutbound(isOutbound);
                if (env === 'production') {
                    // 生产环境用普通链接（只对生产有效）
                    jumpUrl = `https://edc-saas.huimeihealth.com.cn/urllink/cso/patient?flowCode=${_flowCode}&flowType=DrugOrder&tenantCode=${localStorage.getItem('tenantCode') || ''}&sourceType=${sourceType}&drugState=${drugState}&strategyName=${strategyName}&aliasName=${needAliasName ? (encodeURIComponent(aliasName || '') || '') : ''}&planCode=${orderPlanCode}&drugName=${(encodeURIComponent(orderDrug.name || '') || '')}&drugType=${(orderDrug.type || '')}&singleDrug=${orderSingleDrug || ''}`;
                    setWxUrl(jumpUrl);
                } 
                // else if (isOutbound) {
                //     const suRes: any = await api.getProjectSupplier({
                //         tenantCode: localStorage.getItem('tenantCode') || '',
                //         doctorCode: doctorInfo.code
                //     });
                //     if (suRes && suRes.code == 0) {
                //         const suData = suRes.data || {};
                //         jumpUrl = `http://yfw.yaoxielink.com/home.html?qrcode_code=${outTargetUrl || ''}&userid=${doctorInfo.code || ''}`;
                //         setWxUrl(jumpUrl);
                //     } else {
                //         jumpUrl = `http://yfw.yaoxielink.com/home.html?qrcode_code=${outTargetUrl || ''}&userid=${doctorInfo.code || ''}`;
                //         setWxUrl(jumpUrl);
                //     }
                // } 
                else {
                    // jumpUrl = `https://edc-saas-test.huimeimt.com/urllink/cso/patient?flowCode=${_flowCode}`;
                    // 测试环境生成urlLink
                    getWxMiniProgramUrl(_flowCode, sourceType, drugState, strategyName, aliasName, needAliasName, orderDrug, orderPlanCode, orderSingleDrug);
                }
            }
        });
    }

  // 获取小程序id和跳转路径
  const getSourceData = async (treatmentPlanCode: string) => {
    const parmas = {};
    const res: any = await api.getTreatmentPlanDetail(treatmentPlanCode);
    if (res.code == 0) {
    //   const data = res.data || {};
    //   const channel = data.channel;
    //   return channel.wxAppId == 'wxfcf0410b76abcfa1' ? 'xiaohui' : 'gaoji' // 小惠商城
      return res.data || {};
    }
    return {};
  }

    const getInfo = () => {
        return new Promise((resolve, reject) => {
            let urlParams = utils.getUrlParams();
            let code = urlParams.code || '';
            let projectCode = urlParams.projectCode || '';
            let ApiRequest = api.getPlanDetail;
            if (!code) {
                let doctor_info = sessionStorage.getItem('cso_doctor_info') || '{}';
                const doctorInfo: any = JSON.parse(doctor_info);
                code = projectCode || doctorInfo.projects[0]?.code;
                ApiRequest = api.getPlanRecommendDetail;
            }
            code && ApiRequest({
                code: code
            }).then((res: any) => {
                if (res.code == 0) {
                    const _data = res.data || {};
                    setDrugs(_data.drugs || []);
                    setPlanCode(_data.planCode);
                    setShowPoster(_data.showPoster);
                    resolve(_data);
                }
            });
        })
    }

    const getWxMiniProgramUrl = (flowCode: string, sourceType: string, drugState: string, strategyName: string, aliasName: string, needAliasName: any, orderDrug: any, orderPlanCode: any, orderSingleDrug: any) => {
        let doctor_info = sessionStorage.getItem('cso_doctor_info') || '{}';
        const doctorInfo: any = JSON.parse(doctor_info);
        return new Promise<void>((resolve) => {
            let envVersion = 'release';
            // 开发环境 开发版
            if (env === 'development') {
                envVersion = 'trial'; // develop
            }
            // 测试环境 体验版
            else if (env === 'test') {
                envVersion = 'trial';
            }
            // 生产环境 正式版
            else if (env === 'production') {
                envVersion = 'release';
            }
            api.apiAppSecretGenerateUrl({// getAppSecretScheme
                appCode: 'CSO_PT',
                envVersion: envVersion,
                path: 'pages/index/index',
                query: `flowCode=${flowCode}&doctorCode=${doctorInfo.code}&flowType=DrugOrder&tenantCode=${localStorage.getItem('tenantCode') || ''}&sourceType=${sourceType}&drugState=${drugState}&strategyName=${strategyName}&aliasName=${needAliasName ? (encodeURIComponent(aliasName || '') || '') : ''}&planCode=${orderPlanCode}&drugName=${(encodeURIComponent(orderDrug.name || '') || '')}&drugType=${(orderDrug.type || '')}&singleDrug=${orderSingleDrug || ''}`,
            }).then((res: any) => {
                if (res.code == 0) {
                    let _data = res.data || '';
                    setWxUrl(_data);
                }
                resolve();
            });
        });
    }

    const updateQRcode = () => {
        if (env !== 'production' && !isOutbound) {
            getWxMiniProgramUrl(flowCode, sourceType, drugState, strategyName, aliasName, needAliasName, orderDrug, orderPlanCode, orderSingleDrug);
        }
    }
    
    const getPoster = () => {
        if (utils.isMiniProgram()) {
            (window as any).wx.miniProgram.navigateTo({
                url: `/pages/prescriptionPoster/prescriptionPoster?treatmentPlanCode=${treatmentPlanCode}&url=${encodeURIComponent(wxUrl)}`,
                success: function (e: any) {
                },
                fail: function (e: any) {
                }
            })
        }
        // 放置于小程序中生成海报
        // api.generateTreatmentPlanPoster({
        //     "treatmentPlanCode": treatmentPlanCode,
        //     "url": wxUrl
        // }).then((res: any) => {
        //     if (res.code == 0) {
        //         setImgUrl(res.data);
        //     }
        // });
    }

    const toExpand = () => {
        setIsExpand(!isExpand);
    }

    return (
        <div className={styles.covid_content}>
            <div className={styles.top}>
            </div>
            <div className={`${styles.fold_head} ${isExpand ? styles.fold_head_fold : ''}`}>
                <div className={styles.fold_head_l}>
                    <img src={fold_title} alt="" />
                </div>
                <div className={styles.fold_head_r}>
                    <img className={`${isExpand ? styles.fade : ''}`}  src={fold_hospital} alt="" />
                </div>
            </div>
            <div className={`${styles.up} ${isExpand ? '' : styles.fold}`}>
                {
                    !isExpand &&
                    <img className={styles.fold_cover} src={fold_cover} alt="" />
                }
                <img className={styles.plus_fold} src={plus_fold} alt="" />
                {
                    (!drugs || drugs.length == 0) &&
                    <div className={styles.up_item}>
                        <div className={styles.what_is}>
                            药品名称：
                        </div>
                        <div className={styles.fact_is}>
                            
                        </div>
                        <div className={styles.what_is}>
                            用法：
                        </div>
                        <div className={styles.fact_is}>
                        </div>
                        <div className={styles.what_is}>
                            适用症：
                        </div>
                        <div className={styles.fact_is}>
                        </div>
                        <div className={styles.what_is}>
                            适用人群：
                        </div>
                        <div className={styles.fact_is}>
                        </div>
                    </div>
                }
                {
                    drugs[0] && [drugs[0]].map((val: any, key: number) => (
                        <div className={styles.up_item} key={key}>
                            <div className={styles.what_is}>
                                {
                                    !needAliasName ? '药品名称：' : '通用名：'
                                }
                            </div>
                            <div className={styles.fact_is}>
                                {needAliasName ? val.aliasName : val.name}&nbsp;
                            </div>
                            {/* {
                                isExpand &&  */}
                                <div className={`${styles.content_expand } ${isExpand ? '' : styles.content_collapse}`} >
                                    {
                                        !needAliasName &&
                                        <>
                                            <div className={styles.what_is}>
                                                用法：
                                            </div>
                                            <div className={styles.fact_is}>
                                                {val.useType}&nbsp;
                                            </div>
                                        </>
                                    }
                                    {
                                        !needAliasName ?
                                        <>
                                            <div className={styles.what_is}>
                                                适用症：
                                            </div>
                                            <div className={styles.fact_is}>
                                                {val.adaptDisease}&nbsp;
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className={styles.what_is}>
                                                疾病：
                                            </div>
                                            <div className={styles.fact_is}>
                                                {val?.props?.department}&nbsp;
                                            </div>
                                        </>
                                    }
                                    {
                                        !needAliasName ?
                                        <>
                                            <div className={styles.what_is}>
                                                适用人群：
                                            </div>
                                            <div className={styles.fact_is}>
                                                {val.adaptMember}&nbsp;
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className={styles.what_is}>
                                                用药禁忌：
                                            </div>
                                            <div className={`${styles.fact_is} ${styles.line_2}`}>
                                                {val?.taboo?.length >= 20 ? '请遵医嘱' : (val.taboo || '')}&nbsp;
                                            </div>
                                        </>
                                    }
                                    <div className={styles.what_is}>
                                        数量：
                                    </div>
                                    <div className={styles.fact_is}>
                                        {val.num}&nbsp;
                                    </div>
                                    {/* 占位 */}
                                    { 
                                        needAliasName &&
                                        <>
                                            <div className={styles.what_is} style={{ visibility: 'hidden' }}>
                                                数量：
                                            </div>
                                            <div className={styles.fact_is} style={{ visibility: 'hidden' }}>
                                                {val.num}&nbsp;
                                            </div>
                                        </>
                                    }
                                </div>
                            {/* } */}
                        </div>
                    ))
                }
                {
                    needFold && !isExpand &&
                    <div className={styles.to_detail} onClick={toExpand}>
                        <div>{ !isExpand ? '查看详情' : '收起'}</div>
                        <img className={`${isExpand ? styles.reverse : ''}`}  src={fold_arrrow_down} alt="" />
                    </div>
                }
                {
                    isExpand &&
                    <>
                        <div className={styles.tp_line}></div>
                        <div className={styles.tip}>
                            <img className={styles.tip_warn} src={warn} alt="" />
                            <span>以上治疗建议仅作参考，请结合患者实际病情合理用药</span>
                        </div>
                    </>
                }
            </div>
            <div className={styles.connect_top}>
                <img className={styles.connect} src={up_down_connect} alt="" />
            </div>
            <div className={styles.down}>
                <div className={styles.d_t}>邀请患者扫码在线咨询</div>
                <div className={styles.d_m}>
                    <div className={styles.qr_bg_wrap_outer}>
                        <div className={styles.qr_bg_wrap} onClick={updateQRcode}>
                            {
                                wxUrl ?
                                <QRCode
                                    id="covid_suggest_qr"
                                    className={styles.qr_code_img_content}
                                    value={wxUrl}  //value参数为生成二维码的链接
                                    size={161} //二维码的宽高尺寸
                                    fgColor="#000000"  //二维码的颜色
                                />
                                :
                                <div className={styles.qr_placeholder}></div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.d_d}>请患者使用微信扫码</div>
            </div>
            {
                showPoster && 
                <div className={styles.get_poster}>
                    <div className={styles.btn_poster} onClick={getPoster}>
                        <img src={get_poster} alt="" />
                        <span>生成海报</span>
                    </div>
                </div>
            }
            <div className={styles.in_bottom}></div>
        </div>
    )
}

export default withRouter(CovidSuggest);